module.exports = __webpack_public_path__ + "img/img-healthins.6aa4fedf.png";